<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" :prop="getProp" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input :value="formatValue"
                :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                :disabled="component.properties.readonly"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, containerMixin } from './mixins'

export default {
  name: 'rc-cal-time',
  mixins: [ componentMixin, inputMixin, containerMixin ],
  props: [ 'component', 'value', 'index', 'labelParameter' ],
  inject: ['initCount'],
  data () {
    return {
      formatTime: 0,
      timer: null
    }
  },
  computed: {
    formatValue () {
      let formatTime = Number(this.formatTime)
      let formatValue = (parseInt(formatTime / 3600) < 10 ? '0' + parseInt(formatTime / 3600) : parseInt(formatTime / 3600)) +
          ' : ' + (parseInt(formatTime % 3600 / 60) < 10 ? '0' + parseInt(formatTime % 3600 / 60) : parseInt(formatTime % 3600 / 60)) +
          ' : ' + (parseInt(formatTime % 3600 % 60) < 10 ? '0' + parseInt(formatTime % 3600 % 60) : parseInt(formatTime % 3600 % 60))
      return formatValue
    }
  },
  methods: {
    initComponent () {
      // 初次打开
      // todo 父级没有state,暂时先写死
      let reportState = 'create'
      let componentAttr = this.component.properties

      // 初次打开时间和近次在表单里面一样
      if (reportState === 'create') {
        // 表单为第一次编辑的时候
        let date = 0
        if (componentAttr.calTimeType === 'countdown') {
          date = this.getCountDown(componentAttr, date)
        }
        date = parseInt(date / 1000)
        this.getDynamicTime(date, componentAttr.calTimeType)
      } else {
        this.formatTime = this.value
      }
    },
    getCountDown (componentAttr, data) {
      let countDown = parseInt(componentAttr.time.HH * 3600) + parseInt(componentAttr.time.mm * 60) + parseInt(componentAttr.time.ss)
      return countDown * 1000 - data
    },
    getDynamicTime (date, calTimeType) {
      // 正计时 + 1 ， 倒计时 -1
      let state = calTimeType === 'countdown' ? -1 : 1
      this.timer = setInterval(() => {
        date = date + parseInt(state) > 0 ? date + parseInt(state) : 0
        this.formatTime = date
        this.update(date)
        // 触发值改变事件
        this.$nextTick(() => this.executeFunctions('change'))
      }, 1000)
    }

  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  watch: {
    'initCount.value' (val) {
      if (val > 0) {
        this.timer && clearInterval(this.timer)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-cal-time.vue